import { Icon } from "@circle-react-shared/Icon";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

export const TooltipIcon = ({
  tooltipKey,
  tooltipProps,
}: {
  tooltipKey: string;
  tooltipProps: Record<string, unknown>;
}) => (
  <TippyV2 content={t(tooltipKey, tooltipProps)}>
    <span className="flex items-center">
      <Icon type="16-info" size={16} className="ml-2" />
    </span>
  </TippyV2>
);
